import { fromUnixTime, isBefore } from 'date-fns'
import countdownLib from 'countdown'
import { NAMINGS,PRICE_DISPLAY } from './constants'

export const getNextToGo = (racesArray, length = 3) => {
  const races = racesArray ? [].concat.apply([], racesArray) : []
  //do a filter first
  let filteredRaces = races.filter(r => r.status === 'OPEN' && ['THOROUGHBRED', 'HARNESS'].includes(r.meeting.type))
  //then sort use simple new Date instead of moment as it's faster
  if(filteredRaces.length == 0){
    filteredRaces = races.slice(-3)
  }
  return filteredRaces.sort((a, b) => new Date(a.startTime) <= new Date(b.startTime) ? -1 : 1).slice(0, length)
}

export const countdown = function (unixSeconds) {
  const time = fromUnixTime(unixSeconds)
  var ts = countdownLib(time)
  var formatted = ''
  if (ts.months > 1) {
    formatted = ts.months + ' months'
  } else if (ts.days === 0) {
    if (ts.hours === 0 && ts.minutes >= 5) {
      formatted = ts.minutes + 'm '
    } else if (ts.hours === 0 && ts.minutes <= 5 && ts.minutes > 0) {
      formatted = ts.minutes + 'm ' + ts.seconds + 's'
    } else if (ts.hours === 0 && ts.minutes === 0) {
      formatted = ts.seconds + 's'
    } else {
      formatted = ts.hours + 'h ' + ts.minutes + 'm'
    }
  } else {
    formatted = ts.days + 'd'
  }

  if (isBefore(time, Date.now())) {
    formatted = '-' + formatted
  }
  return formatted
}

export const countdownObject = function (unixSeconds) {
  const time = fromUnixTime(unixSeconds)
  return countdownLib(time)
}


export const getTicketStatusName = function (v,ticketObject,venueName) {
  const name = NAMINGS
  // if previouslyPaid is 1, it means the ticket has been cashed before
  if(ticketObject.previouslyPaid){
    return 'Already Cashed'
  }
  if (v === 'paid') {
    const searchWord = ticketObject.balance ? v : 'No Win'
    const status = name.find(c => c.word === searchWord  && c.venueName === venueName)?.replaceWith
    return status || searchWord
  } else {
    const status = name.find(c => c.word === v  && c.venueName === venueName)?.replaceWith
    return status || v
  }
}


export const getBetTypeName = function (v,venueName) {
  const display = PRICE_DISPLAY
  const type = display.find(c => c.platformType === v  && c.venueName === venueName)?.betType
  return type
}

export const getRefundName = function (v,venueName){
  return NAMINGS.find(n=>n.word===v && n.venueName == venueName)?.replaceWith || v

}

export const debounce = function (func, wait = 1000, immediate = true){
  var timeout;

  return function executedFunction() {
    var context = this;
    var args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };

    var callNow = immediate && !timeout;
	
    clearTimeout(timeout);

    timeout = setTimeout(later, wait);
	
    if (callNow) func.apply(context, args);
  };
}

export const isUserHasAccessToVenue = function (userGroups, venueCode){
  return userGroups.includes(venueCode) || userGroups.includes('Betmakers')
}


export const formatMoney = function (value){
  let amount = parseFloat(value)?.toFixed(2)
  if(amount){
    return (amount <  0 ? '-$':'$') + Math.abs(amount)?.toString()?.replace(new RegExp(/(\d)(?=(\d{3})+(\.(\d){0,2})*$)/g),'$1,')
  }     
  else{
      return value
  }
}